import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "section-heading" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mt-3" }, "Blocked Senders")
], -1)
const _hoisted_2 = { class: "row mt-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "ml-2" }, "Blocker Sender")
], -1)
const _hoisted_4 = { class: "col-10 mb-1" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 d-flex justify-content-end mt-3" }
const _hoisted_7 = { class: "row mt-3" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "table w-100" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col-11" }, "Sender"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-1" }, "Delete")
  ])
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  colspan: "5",
  style: {"text-align":"center","color":"red"}
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    style: {"text-align":"center"}
  }, " No blocked senders found ")
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    style: {"text-align":"center"}
  }, " Loading blocked senders... ")
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 3 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col d-flex justify-content-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!
  const _component_VPagination = _resolveComponent("VPagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailAddress) = $event))
        }, null, 512), [
          [_vModelText, _ctx.emailAddress]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn btn-danger mr-1",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.blockSender()))
        }, " Block ")
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", _hoisted_9, [
          _hoisted_10,
          (_ctx.error != '')
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.error), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.error == '' && !_ctx.loading && _ctx.rules.length == 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.loading && _ctx.error.length != 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, _hoisted_18))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.rules.length > 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (rl) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: rl.id,
                    class: _normalizeClass(rl.id == (_ctx.rule || {}).id ? 'selected-row' : ''),
                    onClick: _withModifiers(($event: any) => (_ctx.getRule(rl.id, true)), ["prevent"])
                  }, [
                    _createElementVNode("td", null, _toDisplayString(rl.value), 1),
                    _createElementVNode("td", {
                      style: {"text-align":"center"},
                      "data-toggle": "tooltip",
                      "data-placement": "button",
                      title: "Delete",
                      onClick: ($event: any) => (_ctx.deleteBlockedSender(rl.id))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "text-secondary",
                        icon: ['fas', 'trash']
                      })
                    ], 8, _hoisted_21)
                  ], 10, _hoisted_20))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_confirm_dialog, { ref: "confirmDialog" }, null, 512),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_VPagination, {
              pagination: _ctx.rulesPagination,
              "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rulesPagination) = $event)),
              onPageChanged: _cache[3] || (_cache[3] = (page) => (_ctx.currentPage = page))
            }, null, 8, ["pagination"])
          ])
        ])
      ])
    ])
  ]))
}